module.exports = __webpack_public_path__ + "img/headshot-alan.a9fc330e.png";